
//TODO muss mit der finalen Keycloak URL ersetzt werden. Es ist ein PROD BUILD, wenn es in einer JAR oder einfach
// so ohne npm verwendet wird!
// Irgendwo steht auch noch herokuapp (zumindest sagt das die Netzerwerkanalyse im Browser!)
const prod = {
  url: {
    KEYCLOAK_BASE_URL: "https://auth.glow.btc-ag.cloud",
    API_BASE_URL: "https://app.glow.btc-ag.cloud/glow"
  }
}

const dev = {
  url: {
    KEYCLOAK_BASE_URL: "http://localhost:8080",
    API_BASE_URL: 'http://localhost:11211'
  }
}

export const config = process.env.NODE_ENV === 'development' ? dev : prod